import './Navbar.css'

function Navbar({
    searchInput,
    onSearchInputChange,
    selectedRegion,
    onRegionChange,
    classe
}) {

    return (
        <div id='navbar' className={classe ? 'navbar-dark-mode' : 'navbar-light-mode'}>
            <div className='searchbar'>
                <span className="material-symbols-outlined">
                    search
                </span>
                <input type='text' placeholder='Search for a country...' value={searchInput} onChange={onSearchInputChange}></input>
            </div>
            <select name='region' value={selectedRegion} onChange={onRegionChange}>
                <option value={'Africa'}>Africa</option>
                <option value={'Americas'}>America</option>
                <option value={'Asia'}>Asia</option>
                <option value={'Europe'}>Europe</option>
                <option value={'Oceania'}>Oceania</option>
            </select>
        </div>
    )
}

export default Navbar